"use client"

import { Button } from "@/components/ui/Button"
import { BookmarksPanel, getClientUserEmail } from "@/features/bookmarks"
import { Bookmark } from "lucide-react"
import { useEffect, useState } from "react"

/**
 * Navigation button for accessing user's bookmarks
 *
 * Displays a side panel with the user's bookmarks.
 * Only shows if user is authenticated.
 */
export default function BookmarksNavButton() {
  const [userEmail, setUserEmail] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // Fetch user email on component mount
    getClientUserEmail()
      .then(setUserEmail)
      .finally(() => setIsLoading(false))
  }, [])

  // Don't render during loading or if not authenticated
  if (isLoading || !userEmail) {
    return null
  }

  return (
    <BookmarksPanel
      userEmail={userEmail}
      side="right"
      trigger={
        <Button
          variant="ghost"
          size="sm"
          className="gap-2"
          aria-label="My favourites"
        >
          <Bookmark className="h-4 w-4" />
          <span className="hidden sm:inline">Bookmark</span>
        </Button>
      }
    />
  )
}
